import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  Checkbox,
  Tabs,
  message,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import adminService from "../../../../services/adminService";

const { confirm } = Modal;

const ManageUserModal = ({
  isModalOpen,
  handleModalCancel,
  userData,
  onUpdateUser,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageText, setMessageText] = useState("");

  const handleSendMessage = async () => {
    if (!messageText || !userData?.id) {
      return message.warning("Bitte Nachricht eingeben.");
    }

    try {
      await adminService.sendUserMessage(userData.id, messageText);
      setMessageText(""); // zurücksetzen
    } catch (err) {
      console.error("Nachricht senden fehlgeschlagen:", err);
    }
  };

  useEffect(() => {
    if (isModalOpen && userData) {
      console.log(userData);
      form.setFieldsValue({
        name: userData.name,
        email: userData.email,
        role: userData.role,
        registeredAt: userData.registered,
        subscriptionStatus: userData.status,
        isBlocked: userData.isBlocked,
      });
    }
  }, [isModalOpen, userData, form]);

  const handleFormSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      onUpdateUser(values);
      setTimeout(() => {
        setLoading(false);
        handleModalCancel();
        message.success("Änderungen gespeichert!");
      }, 1000);
    });
  };

  const handleDeleteUser = async () => {
    confirm({
      title: "Benutzer wirklich löschen?",
      icon: <ExclamationCircleOutlined />,
      content: "Diese Aktion kann nicht rückgängig gemacht werden!",
      okText: "Ja, löschen",
      okType: "danger",
      cancelText: "Abbrechen",
      onOk() {
        adminService.deleteUser(userData.id);
        handleModalCancel();
      },
    });
  };

  return (
    <Modal
      title="Nutzer verwalten"
      open={isModalOpen}
      onCancel={handleModalCancel}
      footer={[
        <Button key="reset" onClick={() => form.resetFields()}>
          Änderungen zurücksetzen
        </Button>,
        <Button
          key="submit"
          type="primary"
          className="bg-orange-500 hover:!bg-orange-600"
          loading={loading}
          onClick={handleFormSubmit}
        >
          Speichern
        </Button>,
      ]}
    >
      <Tabs defaultActiveKey="1">
        {/* TAB 1: Allgemeine Infos */}
        <Tabs.TabPane tab="Allgemein" key="1">
          <Form form={form} layout="vertical">
            <Form.Item name="name" label="Name">
              <Input disabled />
            </Form.Item>
            <Form.Item name="email" label="E-Mail">
              <Input disabled />
            </Form.Item>
            <Form.Item name="role" label="Rolle">
              <Select>
                <Select.Option value="Admin">Admin</Select.Option>
                <Select.Option value="Basic User">Basic User</Select.Option>
                <Select.Option value="Standard User">
                  Standard User
                </Select.Option>
                <Select.Option value="Pro User">Pro User</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="registeredAt" label="Registriert am">
              <Input disabled />
            </Form.Item>
          </Form>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Abo-Details" key="2">
          <div className="space-y-2 text-sm text-gray-700">
            <p>
              <strong>Plan:</strong>{" "}
              {userData?.subscription?.planName || "Unbekannt"}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              <span
                className={`font-semibold ${
                  userData?.subscription?.status === "active"
                    ? "text-green-600"
                    : userData?.subscription?.status === "canceled"
                    ? "text-red-600"
                    : "text-yellow-600"
                }`}
              >
                {userData?.subscription?.status || "unbekannt"}
              </span>
            </p>
            <p>
              <strong>Laufzeit:</strong>{" "}
              {userData?.subscription?.contractDuration} Monate
            </p>
            <p>
              <strong>Start:</strong>{" "}
              {new Date(userData?.subscription?.startDate).toLocaleDateString()}
            </p>
            <p>
              <strong>Periode endet:</strong>{" "}
              {new Date(
                userData?.subscription?.currentPeriodEnd
              ).toLocaleDateString()}
            </p>
            <p>
              <strong>Nächste Abbuchung:</strong>{" "}
              {new Date(
                userData?.subscription?.nextBillingDate
              ).toLocaleDateString()}
            </p>
            {userData?.subscription?.endDate && (
              <p>
                <strong>Abo-Ende (nach Kündigung):</strong>{" "}
                {new Date(userData?.subscription?.endDate).toLocaleDateString()}
              </p>
            )}
            <p>
              <strong>Kündigung vorgemerkt:</strong>{" "}
              {userData?.subscription?.pendingCancellation
                ? "✅ Ja"
                : "❌ Nein"}
            </p>
          </div>
        </Tabs.TabPane>

        {/* TAB 3: Aktionen */}
        <Tabs.TabPane tab="Aktionen" key="3">
          <Form form={form} layout="vertical">
            <Form.Item name="isBlocked" valuePropName="checked">
              <Checkbox>Benutzer sperren / deaktivieren</Checkbox>
            </Form.Item>

            <Form.Item label="Nachricht an Benutzer">
              <Input.TextArea
                placeholder="Hier Nachricht eingeben..."
                rows={3}
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
              />
              <Button
                type="primary"
                className="bg-orange-500 hover:!bg-orange-600 mt-2"
                onClick={handleSendMessage}
                disabled={!messageText.trim()}
              >
                Nachricht senden
              </Button>
            </Form.Item>

            <Button
              danger
              type="primary"
              onClick={handleDeleteUser}
              style={{ marginTop: 16 }}
            >
              Benutzer löschen
            </Button>
          </Form>
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};

export default ManageUserModal;
